import React from 'react';
import styled from 'styled-components';

import { Nullable } from '@tager/web-core';
import {
  convertThumbnailToPictureProps,
  ThumbnailType,
} from '@tager/web-modules';

import Picture from '@/components/Picture';
import { colors } from '@/constants/theme';
import { CategoryShort } from '@/typings/model';

type Props = {
  title: string;
  image: Nullable<ThumbnailType> | undefined;
  categories: Array<Pick<CategoryShort, 'name' | 'urlAlias'>>;
};

const Hero = ({ title, image, categories }: Props) => {

  if(!categories.length) return  null;

  const category = categories[0];

  return (
    <Component>
      <Title>{title}</Title>
      <ImageWrapper>
        <Inner>
          <Image {...convertThumbnailToPictureProps(image)} />
          {category && <Category>{category.name}</Category>}
        </Inner>
      </ImageWrapper>
    </Component>
  );
};

export default Hero;

const Component = styled.div``;
const Title = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
`;
const Image = styled(Picture)`
  position: absolute;
  width: 100%;
  height: 100%;

  picture,
  img {
    width: 100%;
    height: 100%;
  }
`;
const ImageWrapper = styled.div`
  margin: 0 -15px;
`;

const Inner = styled.div`
  position: relative;
  padding-bottom: min(47.77%, 400px);
`;

const Category = styled.div`
  position: absolute;
  padding: 0 7px;
  left: 0;
  bottom: 1px;
  background: ${colors.primary};
  color: ${colors.white};
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 22px;
`;
